// File: FraudScoreGauge.js
import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, LinearScale);

// Function to determine the gradient color and risk level
const getGradientDetails = (ctx, score) => {
  const gradient = ctx.createLinearGradient(0, 0, 300, 0);
  if (score > 0) {
    gradient.addColorStop(0, "#FFF065"); // Green
    gradient.addColorStop(1, "#37B450"); // Darker Green
    return { gradient, risk: "Positive Score" };
  } else if (score < 0) {
    gradient.addColorStop(0, "#EBE30099"); // Yellow
    gradient.addColorStop(1, "#E03B24"); // Red
    return { gradient, risk: "total score" };
  }
  gradient.addColorStop(0, "#F6F6F9"); // Neutral gray
  gradient.addColorStop(1, "#F6F6F9");
  return { gradient, risk: "Neutral" };
};

const FraudScoreGauge = ({ score }) => {
  const data = {
    datasets: [
      {
        data: [Math.abs(score), 100 - Math.abs(score)], // Actual score and filler
        backgroundColor: (chart) => {
          const ctx = chart.chart.ctx; // Get the canvas context
          const { gradient } = getGradientDetails(ctx, score);
          return [gradient, "#e9ecef"]; // Gradient for the gauge, gray for filler
        },
        borderWidth: 0,
        cutout: "70%", // Hollow center
        rotation: -90, // Start at the top
        circumference: 180, // Semi-circle
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false }, // Disable default tooltips
    },
    layout: {
      padding: 10,
    },
  };

  // Plugin for adding text in the center
  const customLabelsPlugin = {
    id: "customLabels",
    beforeDraw(chart) {
      const { width } = chart;
      const { ctx } = chart;
      ctx.save();

      // Determine the text and color
      const { risk } = getGradientDetails(ctx, score);

      // Main Score
      ctx.font = "bold 20px Arial";
      ctx.textAlign = "center";
      ctx.fillStyle = score >= 0 ? "#28a745" : "#dc3545"; // Green or red
      ctx.fillText(score, width / 2, chart.chartArea.top + 100);

      // Risk Label
      ctx.font = "16px Arial";
      ctx.fillStyle = "#495057";
      ctx.fillText(risk, width / 2, chart.chartArea.top + 130);

      // Total Score Label
      ctx.font = "12px Arial";
      ctx.fillStyle = "#6c757d";
      ctx.fillText("Total Score", width / 2, chart.chartArea.top + 155);

      ctx.restore();
    },
  };

  return (
    <div>
      <Doughnut data={data} options={options} plugins={[customLabelsPlugin]} />
    </div>
  );
};

export default FraudScoreGauge;
